import {
  NegotiationSettingsWidget as NegotiationSettingsWidgetBase,
  NegotiationSettingsWidgetProps,
} from '@procureai/ui-modules-mui';

import { I18nNamespace } from '~/common/types';
import { ModuleHash } from '~/modules/Module.types';

import { useNegotiationSettingsWidgetBackend } from './NegotiationSettingsWidget.hooks.tsx';

const options: Required<Pick<NegotiationSettingsWidgetProps, 'slotProps' | 'i18n'>> = {
  i18n: {
    ns: I18nNamespace.widgets,
    keyPrefix: 'NegotiationSettingsWidget',
  },
  slotProps: {},
};

export const NegotiationSettingsWidget = () => {
  return (
    <NegotiationSettingsWidgetBase
      useBackend={useNegotiationSettingsWidgetBackend}
      navigationHash={ModuleHash.SOURCING_CASE_NEGOTIATION_SETTINGS}
      intercomTarget={options.i18n.keyPrefix}
      {...options}
    />
  );
};
